<template>
  <div :class="{ hidden: hidden }" class="pagination-container text-center">
    <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout" :page-sizes="pageSizes" :total="total" :hide-on-single-page="true" v-bind="$attrs" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
</template>

<script>
export default {
  name: 'BasePagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    pageindex: {
      type: Number,
      default: 1
    },
    pagesize: {
      type: Number,
      default: 1
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'prev, pager, next, jumper,sizes,total'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    to: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      hidden: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.pageindex
      },
      set(val) {
        this.$emit('update:pageindex', val)
      }
    },
    pageSize: {
      get() {
        return this.pagesize
      },
      set(val) {
        this.$emit('update:pagesize', val)
      }
    }
  },
  watch: {
    total: {
      handler: function(val) {
        this.hidden = this.pageSize > val
      },
      immediate: true
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, pagesize: val })
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, pagesize: this.pageSize })
    }
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 30px;
  background: #fff;
  padding: 32px 16px;
  text-align: center;
}
.pagination-container.hidden {
  display: none;
}
</style>

